module.exports = __webpack_public_path__ + "media/images/footer_page/claims/step1-a9974c885c7c897bb9b8780b077ef8cc.svg";